import { ScoreStarRating } from "../../../../global/score/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";

export const ListingStarRating = () => {
  const listing = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );

  return <ScoreStarRating value={listing.score} spaceBetweenStars="5px" />;
};
